<template>
  <div class="container py-4" style="max-width: 480px;">
    <div class="d-flex align-items-center mb-4">
      <button class="btn btn-link text-dark p-0 me-3" @click="$router.go(-1)">
        <i class="bi bi-arrow-left fs-4"></i>
      </button>
      <h5 class="m-0 fw-bold">Manage Subscriptions</h5>
    </div>

    <h6 class="mb-3">Subscription Plans</h6>

    <b-overlay :show="loading">
      <div v-for="(item, index) in listData" :key="index" class="card border-0 shadow-sm text-center p-4 mb-5"
        style="background: linear-gradient(180deg, #dcefff 0%, #ffffff 100%); border-radius: 20px;">

        <h5 class="fw-bold text-dark mb-2">{{ item.plan_title }}</h5>
        <h3 class="fw-bold mb-2">{{ item.plan_duration }} Months</h3>
        <p class="fs-4 fw-bold text-dark mb-4">BDT {{ item.plan_price }}</p>

        <div type="button" class="text-decoration-none text-secondary mb-3 d-block small"
          @click="showBenefits = !showBenefits"> {{ showBenefits ? 'Hide' : 'Show' }} Benefits</div>

        <div v-if="showBenefits">
          <p v-html="item.plan_benefits"></p>
        </div>

        <button @click="goToPayment(item.id)" class="btn btn-dark w-75 rounded-pill py-2 mx-auto d-block">
          Subscribe
        </button>
      </div>
    </b-overlay>

    <!-- <div class="text-center mt-5">
      <a href="#" class="text-warning text-decoration-none small">View Billing History</a>
    </div> -->
  </div>
</template>

<script>
// import RestApi, { baseURL, apiBaseURL } from '@/config'
import RestApi, { apiBaseURL } from '@/config'

export default {
  data () {
    return {
      value: '',
      showBenefits: false,
      listData: [],
      loading: false,
      editItem: '',
      token: this.$route.query.token || '' // Get from URL or default
    }
  },
  created () {
    console.log('Token:', this.token)
    if (!localStorage.getItem('access_token')) {
      const token = this.$route.query.token || ''
      if (token) {
        // this.form.token = token
        localStorage.setItem('access_token', token)
        localStorage.setItem('api_token', token)
        this.$store.dispatch('Auth/setAccessToken', token)
      }
    }
    this.loadData(this.token)
  },
  methods: {
    async loadData (token) {
      this.loading = true
      try {
        // var { data } = await RestApi.getData(baseURL, 'ios/getSubscriptionPlanList')
        var { data } = await RestApi.getData(apiBaseURL, 'admin/ajax/get_subscription_plan_list_for_ios')
        // console.log('Subscription Plans:', data)
        this.listData = data.data
      } catch (error) {
        console.error('Error:', error)
      } finally {
        this.loading = false
      }
    },
    goToPayment (planId) {
      const query = this.$route.query
      query.plan_id = planId
      // Navigate to payment page with the plan ID
      this.$router.push({ name: 'UserPaymentDetails', query: query })
    }
  }
}
</script>

<style scoped>
/* Ensure you have Bootstrap Icons imported or replace <i> with svg */
</style>
